// assets/free-design.js
// Shared "Design it for me" message box, reused by the homepage design-callout
// band, the Browse Designs gallery, and the stamp-designer editor toolbar.
// Plain document-level event delegation (not a Component) since the trigger
// buttons live in three unrelated host contexts, one of them rendered
// client-side after this module has already run — delegation means it works
// regardless of load order or how many triggers/modals a page has.
//
// Markup contract (snippets/free-design-modal.liquid): a [data-free-design-modal]
// overlay with [hidden], containing a [data-free-design-close] button. Any
// element anywhere on the page with [data-free-design-trigger] opens the
// nearest one when clicked.
//
// The modal has two confirm shapes. Normally it is a link into the studio's
// free-design branch. Rendered with `inline: true` it is instead a
// [data-free-design-confirm] button, and confirming dispatches
// `stamp:free-design-confirmed` for the host to act on without navigating —
// which is how the product page fills a design slot in place.
(function () {
  function closestModalFor(trigger) {
    return document.querySelector('[data-free-design-modal]');
  }

  // When the shopper got here from a product page ("Buy now — choose a design")
  // the URL carries which stamp and which design slot. The modal's Continue link
  // is static Liquid, so forward those params onto it at open time or the
  // free-design branch drops the round-trip back to that product.
  function carryProductContext(modal) {
    const link = modal.querySelector('.free-design-modal__ok');
    if (!link || link.dataset.contextApplied === 'true') return;
    const from = new URLSearchParams(window.location.search);
    const extra = ['product', 'slot', 'title', 'size']
      .map(function (key) {
        const value = from.get(key);
        return value ? key + '=' + encodeURIComponent(value) : '';
      })
      .filter(Boolean)
      .join('&');
    if (!extra) return;
    const href = link.getAttribute('href') || '';
    link.setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + extra);
    link.dataset.contextApplied = 'true';
  }

  function open(modal) {
    if (!modal) return;
    carryProductContext(modal);
    modal.hidden = false;
  }

  function close(modal) {
    if (!modal) return;
    modal.hidden = true;
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest && e.target.closest('[data-free-design-trigger]');
    if (trigger) {
      e.preventDefault();
      open(closestModalFor(trigger));
      return;
    }

    const confirmBtn = e.target.closest && e.target.closest('[data-free-design-confirm]');
    if (confirmBtn) {
      e.preventDefault();
      const modal = confirmBtn.closest('[data-free-design-modal]');
      close(modal);
      document.dispatchEvent(new CustomEvent('stamp:free-design-confirmed', { bubbles: true }));
      return;
    }

    const closeBtn = e.target.closest && e.target.closest('[data-free-design-close]');
    if (closeBtn) {
      close(closeBtn.closest('[data-free-design-modal]'));
      return;
    }

    // Click on the backdrop itself (not the card) also dismisses.
    const modal = e.target.closest && e.target.closest('[data-free-design-modal]');
    if (modal && e.target === modal) {
      close(modal);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-free-design-modal]:not([hidden])').forEach(close);
  });
})();
